import { FunctionComponent, useEffect, useRef, useState } from 'react';
import classNames from 'classnames';
import Clipboard from 'clipboard';
import { trackFeature } from '@/utils/adobeLaunch';
import { t } from '@/utils/i18n';
import { isRefDefined } from '@/utils/isRefDefined';
import { CheckMark } from '@/components/common/icons/CheckMark';
import './SharingLink.scss';

interface Props {
  url?: string;
}

export const SharingLink: FunctionComponent<Props> = ({ url }) => {
  const [copied, setCopied] = useState(false);
  const clipboard = useRef<Clipboard>();

  useEffect(() => {
    clipboard.current = new Clipboard('#copy-button');
    clipboard.current.on('success', () => {
      trackFeature('sharing-copy-link');
      setCopied(true);
      setTimeout(() => {
        setCopied(false);
      }, 3000);
    });

    return () => {
      if (isRefDefined(clipboard)) {
        clipboard.current.destroy();
      }
    };
  }, []);

  const urlClassName = classNames(['sharing__url', { 'sharing__url--copied': copied }]);
  const buttonClassName = classNames([
    'sprd-button',
    'sharing__copy',
    { 'sharing__copy--copied': copied },
  ]);

  return (
    <div className="sharing__link">
      <input id="sharing-url" type="text" value={url || ''} className={urlClassName} readOnly />
      <button
        type="button"
        id="copy-button"
        className={buttonClassName}
        data-clipboard-target="#sharing-url"
      >
        {copied && <CheckMark width="1.5em" height="1.5em" />}
        {copied ? t('share.copiedLink') : t('share.copyLink')}
      </button>
    </div>
  );
};
